export const isValueInRange = (x, min, max) => x >= min && x <= max;
//# sourceMappingURL=utils.js.map